import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '@services/auth.service';
import { UiService } from '@services/ui.service';

@Injectable({
    providedIn: 'root'
})
export class LicenceActiveGuard implements CanActivate, CanActivateChild {
    constructor(
        private authSrv: AuthService,
        private uiSrv: UiService
    ) {}
    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

        if(this.checkLicenceValidity()) {
            return true;
        } else {
            if(this.authSrv.isAuth()) {
                this.uiSrv.showSnackbar('auth.licenceInvalid.summary', true, 5000);
            }
            return false;
        }
    }

    canActivateChild(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean  {
        return this.canActivate(route, state);
    }

    private checkLicenceValidity(): boolean {
        const decodedToken = this.authSrv.getDecodedToken();

        if(decodedToken && decodedToken.licence_valid) {
            return true;
        }

        return false;
    }
}
